import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { dashboardLayoutComponent } from '@/routes/layouts/dashboard-layout-route';
import type {
  APISettingsSearch,
  APISettingsTypes,
} from '@/features/profile/app-settings/api-settings.types';

export const profileRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/profile',
  component: lazyRouteComponent(() => import('@/pages/profile/my-profile/profile-page')),
});

export const businessProfileRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/business-profile',
  component: lazyRouteComponent(() => import('@/pages/profile/business-profile')),
});

export const settingsRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/settings',
  component: lazyRouteComponent(() => import('@/pages/profile/settings')),
});

export const manageNotifRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/manage-notifications',
  component: lazyRouteComponent(() => import('@/pages/profile/manage-notifications')),
});

export const apiSettingsRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/api-settings',
  component: lazyRouteComponent(() => import('@/pages/profile/settings/api-settings')),
  validateSearch: (search: Record<string, APISettingsTypes>): APISettingsSearch => {
    return {
      type: search.type,
    };
  },
});

export const changePasswordRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/change-password',
  component: lazyRouteComponent(() => import('@/pages/profile/my-profile/change-password-page')),
});
